"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseContract = void 0;
var types_1 = require("../types");
var mainnet_json_1 = __importDefault(require("./addresses/mainnet.json"));
var goerli_json_1 = __importDefault(require("./addresses/goerli.json"));
var addressesConfig = (_a = {},
    _a[types_1.BlockchainNetworkId.mainnet] = mainnet_json_1.default,
    _a[types_1.BlockchainNetworkId.goerli] = goerli_json_1.default,
    _a);
var BaseContract = /** @class */ (function () {
    function BaseContract(web3, networkId) {
        this.web3 = web3;
        var addresses = addressesConfig[networkId];
        if (!addresses) {
            throw new Error('Contract addresses are not defined');
        }
        this.addresses = addresses;
    }
    /**
     * Get given contract for instance network
     */
    BaseContract.prototype.getContract = function () {
        if (this.web3ContractInstance) {
            return this.web3ContractInstance;
        }
        var address = this.getContractAddress();
        this.web3ContractInstance = new this.web3.eth.Contract(this.abi, address);
        return this.web3ContractInstance;
    };
    BaseContract.prototype.getContractAddress = function () {
        var contractName = this.getName();
        return this.addresses[contractName];
    };
    BaseContract.prototype.getAddresses = function () {
        return this.addresses;
    };
    BaseContract.prototype.getWeb3ContractInstance = function () {
        return this.web3ContractInstance;
    };
    return BaseContract;
}());
exports.BaseContract = BaseContract;
//# sourceMappingURL=BaseContract.js.map